export const testimonials = [
  {
    id: 1,
    name: "Fatima Begum",
    rating: 5,
    text: "Ortho Dental Clinic transformed my smile completely. The teeth whitening results exceeded my expectations. The staff is incredibly professional and caring.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
    treatment: "Teeth Whitening"
  },
  {
    id: 2,
    name: "Mohammad Rahim",
    rating: 5,
    text: "I was terrified of dental implants, but Dr. Tariq made the entire process painless. Now I can smile confidently again. Highly recommend!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    treatment: "Dental Implants"
  },
  {
    id: 3,
    name: "Ayesha Khan",
    rating: 5,
    text: "My daughter loves visiting Dr. Nusrat. The pediatric care here is exceptional. They make every visit fun and educational for kids.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
    treatment: "Pediatric Dentistry"
  },
  {
    id: 4,
    name: "Kamal Uddin",
    rating: 5,
    text: "Best orthodontic experience in Dhaka! Dr. Karim's invisible aligners changed my life. Professional, timely, and excellent results.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop",
    treatment: "Orthodontics"
  }
];

export default testimonials;
